// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabComponent_tabContainer__1kmVm","activeTab":"TabComponent_activeTab__16Vbh","defaultTab":"TabComponent_defaultTab__29e0M"};